// extracted by mini-css-extract-plugin
export default {"recos":"Ama-z","productCardOverride":"Bma-z","rowHasBadge":"Cma-z"};